import { useQuery } from '@tanstack/react-query'
import { getWorkflowSummaries } from '@/services/workflowSummary'
import { useActingAs } from '@/state/actingAs'
import { ServiceCard } from './ServiceCard'

export function WorkflowSummaries() {
  // Keyed by the acted-as org (or its absence) so switching who you're acting
  // as — or exiting back to yourself — always shows that identity's own
  // workflows instead of a stale cache entry from whoever it was before.
  const actingAs = useActingAs()
  const summaries = useQuery({
    queryKey: ['workflow-summaries', actingAs?.organizationId ?? null],
    queryFn: getWorkflowSummaries,
  })

  if (summaries.isLoading) {
    return <p className="text-sm text-muted-foreground">Loading workflow summaries...</p>
  }

  if (summaries.isError) {
    return (
      <p className="text-sm text-red-600">Could not load workflow summaries.</p>
    )
  }

  const items = summaries.data ?? []

  if (items.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">No workflows available yet.</p>
    )
  }

  // Your services, stacked in a narrow column (a third of the width, a quarter on very wide
  // screens), so one service looks as deliberate as several.
  return (
    <div className="grid gap-6 lg:grid-cols-3 2xl:grid-cols-4">
      <div className="space-y-4">
        {items.map((summary) => (
          <ServiceCard
            key={summary.workflow_id}
            summary={summary}
            showName={items.filter((other) => other.type === summary.type).length > 1}
          />
        ))}
      </div>
    </div>
  )
}
